// /*! Copyright (c) Safe As Milk. All rights reserved. */
// import Cart from "cart-store";

// class ProductForm extends HTMLElement {
//     #boundSubmit;
//     #eventAttached;
//     static #formsBeingProcessed=[];
//     constructor() {
//         super();
//         this.#boundSubmit = this.submit.bind(this);
//     }
//     connectedCallback() {
//         this.#eventAttached = false;
//         setTimeout((() => {
//             this.form = this.querySelector("form");
//             this.idInput = this.form.querySelector('input[name="id"]');
//             this.submitButton = this.form.elements.add;
//             this.stagedAction = this.querySelector("staged-action");
//             this.idInput.removeAttribute("disabled");
//             this.notifyOnAdd = this.hasAttribute("notify-on-add");
//             this.redirectOnAdd = this.getAttribute("redirect-on-add");
//             this.#eventAttached = true;
//             this.form.addEventListener("submit", this.#boundSubmit);
//         }));
//     }
//     disconnectedCallback() {
//         if (this.#eventAttached) {
//             this.#eventAttached = false;
//             this.form.removeEventListener("submit", this.#boundSubmit);
//         }
//     }
//     async submit(e) {
//         e.preventDefault();
//         const data = new FormData(e.target);
//         const item = Object.fromEntries(data.entries());
//         try {
//             this.removeError();
//             if (this.redirectOnAdd && !ProductForm.#formsBeingProcessed.includes(this.form.id)) {
//                 ProductForm.#formsBeingProcessed.push(this.form.id);
//             }
//             if (this.stagedAction) await this.stagedAction.setState("DOING");
//             await Cart.add(item);
//             if (this.redirectOnAdd) {
//                 ProductForm.#formsBeingProcessed = ProductForm.#formsBeingProcessed.filter((id => id !== this.form.id));
//                 if (ProductForm.#formsBeingProcessed.length === 0) {
//                     window.location.href = this.redirectOnAdd;
//                 }
//             }
//             if (this.stagedAction) await this.stagedAction.setState("DONE");
//             const quickShop = this.closest("quick-shop");
//             if (quickShop) {
//                 await quickShop.close();
//             }
//             if (this.notifyOnAdd) {
//                 await Cart.resetVariantsBeingAdded();
//                 if (!this.closest(".modal--cart")) {
//                     const cart = document.querySelector(".modal--cart, .popup--cart-notification");
//                     if (cart && !cart.shown) {
//                         cart.open();
//                     } else if (cart && cart.interval) {
//                         cart.interval.reset();
//                         cart.interval.start();
//                     }
//                 }
//             } else {
//                 await Cart.resetLatestAddedProduct();
//                 await Cart.resetVariantsBeingAdded(item.id);
//             }
//         } catch (error) {
//             this.#renderError(error.message);
//             if (this.stagedAction) await this.stagedAction.setState("IDLE");
//             if (this.redirectOnAdd) {
//                 ProductForm.#formsBeingProcessed = ProductForm.#formsBeingProcessed.filter((id => id !== this.form.id));
//             }
//         }
//     }
//     removeError() {
//         const error = this.querySelector(".errors");
//         if (!error) return;
//         error.remove();
//     }
//     #renderError(message) {
//         this.removeError();
//         if (this.submitButton) {
//             const error = document.createElement("div");
//             error.classList.add("errors", "qty-error", "u-small");
//             error.innerHTML = message;
//             this.submitButton.before(error);
//         }
//     }
// }

// customElements.define("product-form", ProductForm);
// //# sourceMappingURL=product-form.js.map


/*! Copyright (c) Safe As Milk. All rights reserved. */
import Cart from "cart-store";

class ProductForm extends HTMLElement {
    #boundSubmit;
    #eventAttached;
    static #formsBeingProcessed=[];
    constructor() {
        super();
        this.#boundSubmit = this.submit.bind(this);
    }
    connectedCallback() {
        this.#eventAttached = false;
        setTimeout((() => {
            this.form = this.querySelector("form");
            this.idInput = this.form.querySelector('input[name="id"]');
            this.submitButton = this.form.elements.add;
            this.stagedAction = this.querySelector("staged-action");
            this.idInput.removeAttribute("disabled");
            this.notifyOnAdd = this.hasAttribute("notify-on-add");
            this.redirectOnAdd = this.getAttribute("redirect-on-add");
            this.#eventAttached = true;
            this.form.addEventListener("submit", this.#boundSubmit);
        }));
    }
    disconnectedCallback() {
        if (this.#eventAttached) {
            this.#eventAttached = false;
            this.form.removeEventListener("submit", this.#boundSubmit);
        }
    }
    async submit(e) {
        e.preventDefault();

        // Added By MLVeda - check for add to cart availability

         const isProductAddable = await this.canProductAddedToCart();

        if(!isProductAddable){
            if(document.querySelector('glace-modal')){
                document.querySelector('glace-modal').open();
            }else{
                this.#renderError("Glacé must be purchased separately. Please remove other items from your cart to continue.");
            }
            return;
        }

        // Added By MLVeda
        const data = new FormData(e.target);
        const item = Object.fromEntries(data.entries());
        const addonItems = [];

        for (let i = 1; i <= 4; i++) { 
            if (item[`items[${i}][parent_id]`] === item.id) {
                addonItems.push({
                    quantity: Number(item[`items[${i}][quantity]`]),
                    form_type: "product",
                    utf8: "✓",
                    parent_id: item.id,
                    id: item[`items[${i}][id]`],
                    "product-id": item["product-id"],
                    "section-id": item["section-id"],
                    "properties[_model]":item[`items[${i}][properties[_model]`],
                    "properties[_addon]":item[`items[${i}][properties[_addon]`]
                });
            }
        }

        Object.keys(item).forEach(key => {
            if (key.startsWith("items[")) {
                delete item[key];  // Delete keys related to items[1], items[2], etc.
            }
        });

        console.log('addonItems',addonItems)
        const finalItems = [item, ...addonItems];
        console.log(finalItems, 124)
        //debugger;
        try {
            this.removeError();
            if (this.redirectOnAdd && !ProductForm.#formsBeingProcessed.includes(this.form.id)) {
                ProductForm.#formsBeingProcessed.push(this.form.id);
            }
            if (this.stagedAction) await this.stagedAction.setState("DOING");
            // await Cart.add(item);
            await Cart.add(finalItems);
            
            if (this.redirectOnAdd) {
                ProductForm.#formsBeingProcessed = ProductForm.#formsBeingProcessed.filter((id => id !== this.form.id));
                if (ProductForm.#formsBeingProcessed.length === 0) {
                    window.location.href = this.redirectOnAdd;
                }
            }
            if (this.stagedAction) await this.stagedAction.setState("DONE");
            const quickShop = this.closest("quick-shop");
            if (quickShop) {
                await quickShop.close();
            }
            if (this.notifyOnAdd) {
                await Cart.resetVariantsBeingAdded();
                if (!this.closest(".modal--cart")) {
                    const cart = document.querySelector(".modal--cart, .popup--cart-notification");
                    if (cart && !cart.shown) {
                        cart.open();
                    } else if (cart && cart.interval) {
                        cart.interval.reset();
                        cart.interval.start();
                    }
                }
            } else {
                await Cart.resetLatestAddedProduct();
                await Cart.resetVariantsBeingAdded(item.id);
            }
        } catch (error) {
            this.#renderError(error.message);
            if (this.stagedAction) await this.stagedAction.setState("IDLE");
            if (this.redirectOnAdd) {
                ProductForm.#formsBeingProcessed = ProductForm.#formsBeingProcessed.filter((id => id !== this.form.id));
            }
        }
    }
    removeError() {
        const error = this.querySelector(".errors");
        if (!error) return;
        error.remove();
    }
    #renderError(message) {
        this.removeError();
        if (this.submitButton) {
            const error = document.createElement("div");
            error.classList.add("errors", "qty-error", "u-small");
            error.innerHTML = message;
            this.submitButton.before(error);
        }
    }

    async canProductAddedToCart(){
        // Glace product will purchase individual

        // If current product is Glace and already other prdoucts are in cart then dont allow add to cart Together

        // If Glace product in cart and other product add to cart then dont allow add to cart Together

        const isCurrentProductIsGlace = this.querySelector('input[name="properties[_capitalDevice]"]');
        const currentCart = await fetch('/cart.js').then(res => res.json());;
        const cartItems = currentCart.items;
        let returnValue = true;

        if(cartItems && cartItems.length > 0){
            for (const item of cartItems) {
                if(isCurrentProductIsGlace){
                    // check for other products
                    if(item.parent_relationship && item.parent_relationship.parent_key){
                        continue;
                    }

                    if(item.properties['_capitalDevice']){
                        continue;
                    }
                    returnValue = false;
                    break
                }else{
                    // check for Glace product
                    if(item.properties['_capitalDevice']){
                        returnValue = false;
                    break
                    }
                }
            }
        }else{
            returnValue = true;
        }

        return returnValue;
    }
}

customElements.define("product-form", ProductForm);
//# sourceMappingURL=product-form.js.map
